import type { CauseOfDeath } from "shared/types";
import {
  type CauseOfDeathDispatchAction,
  LIST_FARM_CAUSES_OF_DEATH,
} from "../actions";

export type CauseOfDeathState = {
  farmCausesOfDeath: CauseOfDeath[];
};

export const initialState: CauseOfDeathState = {
  farmCausesOfDeath: [],
};

export default function causeOfDeathReducer(
  state: CauseOfDeathState = initialState,
  action: CauseOfDeathDispatchAction
): CauseOfDeathState {
  if (action.type === LIST_FARM_CAUSES_OF_DEATH) {
    return {
      ...state,
      farmCausesOfDeath: action.payload.causesOfDeath,
    };
  }

  return { ...state };
}
